import { useState } from "react";
import { generateOfflineCode } from "../../utils/offlineCode";

// Componente para gerar código de liberação offline no dashboard
export function OfflineCodeGenerator() {
	const [devicePassword, setDevicePassword] = useState("");
	const [generatedCode, setGeneratedCode] = useState("");

	const handleGenerate = () => {
		if (devicePassword.length >= 4) {
			const code = generateOfflineCode(devicePassword);
			setGeneratedCode(code);
		}
	};

	return (
		<div
			style={{
				padding: 20,
				border: "1px solid #ccc",
				borderRadius: 8,
				maxWidth: 400,
			}}
		>
			<h3 style={{ marginTop: 0 }}>Gerar Código de Liberação Offline</h3>
			<p style={{ fontSize: 14, color: "#666" }}>
				Código válido por 1 dia para dispositivo específico
			</p>

			<input
				type="text"
				value={devicePassword}
				onChange={(e) => setDevicePassword(e.target.value)}
				placeholder="Senha do dispositivo"
				style={{ padding: 8, width: "100%", marginBottom: 12 }}
			/>

			<button
				type="button"
				onClick={handleGenerate}
				style={{ padding: "8px 16px" }}
			>
				Gerar Código
			</button>

			{generatedCode && (
				<div
					style={{
						marginTop: 16,
						padding: 16,
						background: "#f0f0f0",
						borderRadius: 4,
					}}
				>
					<p style={{ margin: 0, fontSize: 12 }}>Código de liberação:</p>
					<p
						style={{
							margin: 0,
							fontSize: 32,
							fontWeight: "bold",
							letterSpacing: 4,
						}}
					>
						{generatedCode}
					</p>
					<p style={{ margin: "8px 0 0", fontSize: 12, color: "#666" }}>
						Válido até: {new Date().toLocaleDateString("pt-BR")}
					</p>
				</div>
			)}
		</div>
	);
}
